<template>
  <BaseLayout>
    <div class="retrievePasswordOne">
      <div class="h f-y-center m-b-55 m-l-75 m-r-75">
        <img class="RegisteredLogoImage" src="./assets/registered-logo.png" />
        <div class="f-x-center f-column">
          <div class="title m-b-15">欢迎使用律小购</div>
          <div class="label">法律人工智能服务平台</div>
        </div>
      </div>
      <div class>
        <div class="login-input-box">
          <img class="registeredInputNameImage icon" src="./assets/registered-input-name.png" />
          <input
            type="text"
            class="input p-l-100"
            :class="{'input-error' : requiredErrorKey === 'account'}"
            :ref="el => nodes.accountNode.value = el"
            v-model="form.account"
            placeholder="设置您的登录账号"
            @blur="blurEvent"
          />
        </div>
        <div class="login-input-box">
          <img class="registeredInputPhoneImage icon" src="./assets/registered-input-phone.png" />
          <input
            type="text"
            class="input p-l-100"
            :class="{'input-error' : requiredErrorKey === 'mobile'}"
            :ref="el => nodes.mobileNode.value = el"
            v-model="form.mobile"
            placeholder="输入您的手机号"
            @blur="blurEvent"
          />
        </div>
        <div class="login-input-box">
          <img
            class="registeredVerificationCodeImage icon"
            src="./assets/registered-verification-code.png"
          />
          <input
            type="text"
            class="input p-l-100"
            :class="{'input-error' : requiredErrorKey === 'mobileVerificationCode'}"
            :ref="el => nodes.mobileVerificationCodeNode.value = el"
            v-model="form.mobileVerificationCode"
            placeholder="输入验证码"
            @blur="blurEvent"
          />
          <div v-if="remainingTime == null" class="code" @click="getCodeAction">获取验证码</div>
          <div v-else class="code-disabled">{{remainingTime}}后可重新发送</div>
        </div>
      </div>
      <div class="login-input-box">
        <div class="submit" @click="submitEvent">下一步</div>
      </div>
    </div>
  </BaseLayout>
</template>

<script>
import { userApi } from '@/apis'
import { toast } from '@/utils/alert'
import { ref } from 'vue'
import { reactive } from 'vue'
import router from '@/router'

export default {
  setup() {
    document.getElementsByTagName('title')[0].innerText =
      process.env.VUE_APP_RETRIEVEPASSWORDONE_TITLE

    const nodes = {
      accountNode: ref(null),
      mobileNode: ref(null),
      mobileVerificationCodeNode: ref(null),
    }

    const requiredErrorKey = ref('')

    const verify = {
      account: {
        isRequired: true,
        v: () =>
          /[a-zA-Z]\w{3,18}$/g.test(form.account) ||
          /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/g.test(
            form.account
          ),
        msg: '账号设置字母开头包含字母和数字4-18位或邮箱',
      },
      mobile: {
        isRequired: true,
        v: () => /^[1]([3-9])[0-9]{9}$/.test(form.mobile),
        msg: '手机号码设置有误',
      },
      mobileVerificationCode: {
        isRequired: true,
        v: () => form.mobileVerificationCode,
        msg: '',
      },
    }

    const blurEvent = () => {
      requiredErrorKey.value = ''
    }

    const form = reactive({
      account: '', // 账号
      mobile: '', // 手机号码
      mobileVerificationCode: '', // 手机验证码
      password: '',
    })

    const remainingTime = ref(null)

    const timerAction = (time) => {
      if (remainingTime.value === null) {
        remainingTime.value = time
      }
      setTimeout(() => {
        remainingTime.value--
        if (remainingTime.value === 0) {
          remainingTime.value = null
          return
        }
        timerAction(time)
      }, 1000)
    }

    const getCodeAction = async () => {
      if (!form.mobile) {
        toast('填写手机号码')
        return
      }

      const registeredSms = await userApi.registeredSms({ mobile: form.mobile })
      timerAction(registeredSms.data)
    }

    const submitEvent = async () => {
      const verifyKeys = Object.keys(verify)
      console.log('verify', verify)
      const requiredKey = verifyKeys.find((key) => form[key] == '')
      if (requiredKey) {
        const key = requiredKey
        const node = nodes[`${key}Node`]
        node.value.focus()
        requiredErrorKey.value = key
        return
      }

      const login = await userApi.findPwd({
        // account: form.account.toLowerCase(),
        account: /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/g.test(
          form.account
        )
          ? null
          : form.account,
        email: /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/g.test(
          form.account
        )
          ? form.account
          : null,
        mobile: form.mobile,
        mobileVerificationCode: form.mobileVerificationCode,
      })
      router.push({
        path: '/retrievePasswordTwo',
        query: {
          account: form.account.toLowerCase(),
          mobile: form.mobile,
          mobileVerificationCode: form.mobileVerificationCode,
        },
      })
    }
    return {
      nodes,
      form,
      verify,
      blurEvent,
      submitEvent,
      getCodeAction,
      remainingTime,
      requiredErrorKey,
    }
  },
  // components: { ProgressBar },
}
</script>

<style lang="scss">
@import './utils.scss';
.retrievePasswordOne {
  display: flex;
  flex-direction: column;
  padding-top: 60px;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(0deg, #f5f8ff 0%, #ffffff 100%);

  .RegisteredLogoImage {
    width: 75px;
    height: 90px;
    margin-right: 28px;
  }
}
</style>